import React from 'react';
import { createHashRouter, createRoutesFromElements, Route } from 'react-router-dom';

import {
  ACTIVITY_PATH, DISTRIBUTION_PATH,
  EARN_PATH, FRIENDS_PATH,
  HACKATHON_PROJECT_DETAILS_PATH, HOLIDAY_GIVEAWAY,
  HOME_PATH, LEADERBOARD_PATH, RANKING_PATH
} from '@/app/paths';
import { ProtectedRoutes } from '@/widgets';
import {
  Activity,
  Distribution,
  Earn,
  Friends,
  Giveaway,
  HackathonProjectDetails,
  Home,
  Leaderboard,
  Ranking
} from '@/pages';

export const router = createHashRouter(
  createRoutesFromElements(
    <>
      <Route element={<ProtectedRoutes />}>
        <Route path={HOME_PATH} element={<Home />} />
        <Route path={RANKING_PATH} element={<Ranking />} />
        <Route path={FRIENDS_PATH} element={<Friends />} />
        <Route path={EARN_PATH} element={<Earn />} />
      </Route>
      <Route element={<ProtectedRoutes hasBackButtonTo={-1} />}>
        <Route path={HACKATHON_PROJECT_DETAILS_PATH} element={<HackathonProjectDetails />} />
        <Route path={ACTIVITY_PATH} element={<Activity />} />
        <Route path={HOLIDAY_GIVEAWAY} element={<Giveaway />} />
        <Route path={LEADERBOARD_PATH} element={<Leaderboard />} />
        <Route path={DISTRIBUTION_PATH} element={<Distribution />} />
      </Route>
      <Route element={<ProtectedRoutes withoutFooter />}>
        {/*<Route path={FORTUNE_WHEEL_PATH} element={<FortuneWheel />} />*/}
      </Route>
    </>
  )
);

export default router;
